/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Policy_Retention_Logs_LabelInputs */

const es_privacy_policy_retention_logs_label = /** @type {(inputs: Privacy_Policy_Retention_Logs_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logs de Acceso`)
};

const en_privacy_policy_retention_logs_label = /** @type {(inputs: Privacy_Policy_Retention_Logs_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Access Logs`)
};

/**
* | output |
* | --- |
* | "Access Logs" |
*
* @param {Privacy_Policy_Retention_Logs_LabelInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const privacy_policy_retention_logs_label = /** @type {((inputs?: Privacy_Policy_Retention_Logs_LabelInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Policy_Retention_Logs_LabelInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_privacy_policy_retention_logs_label(inputs)
	return en_privacy_policy_retention_logs_label(inputs)
});
export { privacy_policy_retention_logs_label as "privacy_policy.retention.logs_label" }